import { InputLabel, MenuItem, SelectChangeEvent } from '@mui/material';
import { memo } from 'react';
import { __TOPONYMY_API_URL__ } from 'shell/constants/environment';
import { ItemVM } from 'shell/view-models/item';
import { HttpResponseList } from 'shell/models/http-response';
import { CirculationAreaType } from 'shell/models/circulation-area-type';
import { PmiFormControl } from 'shell/components/shared/pmi-select/pmi-form-control';
import { PmiSelect } from 'shell/components/shared/pmi-select';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';

interface AreaTypeProps {
  disabled?: boolean;
  value: string;
  onChange?: (event: SelectChangeEvent<string>) => void;
  error?: boolean;
  required?: boolean;
  label?: string;
}

const AreaTypeComponent = ({
  disabled,
  onChange,
  value,
  error,
  label = 'Tipo',
  required,
}: AreaTypeProps): React.ReactElement => {
  const [areaTypes] = useHttpFetch<HttpResponseList<CirculationAreaType>, Array<ItemVM>>(
    `${__TOPONYMY_API_URL__}/areaCircolazione/tipo`,
    {
      options: {
        method: 'GET',
        errorCatching: true,
        loading: true,
      },
      onBootstrap: true,
      transformer: (response) => {
        return response.data.payload.list?.map((item) => ({
          id: item.key,
          value: item.tipo,
        }));
      },
    }
  );

  const types: Array<ItemVM> = (areaTypes.data as Array<ItemVM>) || [];

  return (
    <PmiFormControl fullWidth error={error}>
      <InputLabel id="type-label" disabled={disabled}>
        {required ? `${label} *` : label}
      </InputLabel>
      <PmiSelect
        labelId="type-label"
        id="type"
        name="type"
        value={value}
        label={required ? `${label} *` : label}
        onChange={onChange}
        disabled={disabled}
        error={error}
      >
        {types.map((type: ItemVM) => (
          <MenuItem key={type.id} value={type.id}>
            {type.value}
          </MenuItem>
        ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

AreaTypeComponent.displayName = 'Area type component';

const AreaType = memo(AreaTypeComponent);

export default AreaType as typeof AreaTypeComponent;
